<template />

<script>
export default {
  props: {
    src: { type: String, required: true }
  },
  mounted() {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = this.src
    document.body.appendChild(s)
  }

}
</script>

<style>

</style>
